export const POTREE_FLAG_KEY = 'xeovision.internal.potree';

export function isPotreeEnabled(): boolean {
  try {
    return localStorage.getItem(POTREE_FLAG_KEY) === '1';
  } catch {
    return false;
  }
}
